import { render, staticRenderFns } from "./UpdateNganLuongFileModal.vue?vue&type=template&id=47f86460&scoped=true"
import script from "./UpdateNganLuongFileModal.vue?vue&type=script&lang=js"
export * from "./UpdateNganLuongFileModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateNganLuongFileModal.vue?vue&type=style&index=0&id=47f86460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f86460",
  null
  
)

export default component.exports